import React, {memo} from 'react';
import {connect} from 'react-redux';
import ProgressBarWithIcon from '../progressBarWithIcon/ProgressBarWithIcon';
import FamilyPackageUsageDetailsPopUp from '../FamilyPackageUsageDetailsPopUp/FamilyPackageUsageDetailsPopUp';
import {useFamilyBundleUsage, familyBundleMapState} from '../hooks/useFamilyBundleUsage';

const ProgressBarWrapper = memo(
  ({
    serviceName,
    servicePackageUnitQuantity,
    servicePackageUnitMeasure,
    icon,
    bgcolor,
    percentageCompleted,
    SocData = {},
    costumerMobile,
    familyBundleMemberUsageData,
    familyBundleCollectiveUsageData,
  }) => {
    const {popupPackageUsages, popupCollectiveUsages, subLabel: topLabel, familyPackageUsagePopup, openPopup, closePopup} = useFamilyBundleUsage({
      SocData:{...SocData, expirationDate: SocData?.endDate || ''},
      costumerMobile,
      familyBundleMemberUsageData,
      familyBundleCollectiveUsageData,
    });

    return (
      <>
        <div className='progress-bar-wrapper'>
          <div className='quantity-and-unit-line'>
            <div className='service-name'>{serviceName}</div>
            <div className='vertical-line' />
            <div className='service-package-unit-quantity'>{servicePackageUnitQuantity}</div>
            <div className='service-package-unit-measure'>{servicePackageUnitMeasure}</div>
          </div>
          <div className='progress-bar-content'>
            {topLabel && (
              <div className='top-label' onClick={openPopup}>
                {topLabel}
              </div>
            )}
            <ProgressBarWithIcon icon={icon} bgcolor={bgcolor} percentageCompleted={percentageCompleted} />
          </div>
        </div>
        <FamilyPackageUsageDetailsPopUp
          showPopUp={familyPackageUsagePopup}
          onClose={closePopup}
          packageUsages={popupPackageUsages}
          collectiveUsages={popupCollectiveUsages}
        />
      </>
    );
  },
);

const mapDispatchToProps = {};
export default connect(familyBundleMapState, mapDispatchToProps)(ProgressBarWrapper);
